import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ArticleCard = ({ article, testId }) => (
  <Link
    to={`/conseils/${article.slug}`}
    data-testid={testId || `blog-card-${article.slug}`}
    className="card-soft card-soft-hover flex flex-col h-full p-7 bg-white group"
  >
    <div className="flex items-center gap-2.5 flex-wrap">
      <span className="rounded-full bg-[#176b70]/10 text-[#176b70] px-3 py-1 text-[11px] font-bold">
        {article.category}
      </span>
      <span className="text-[11px] font-semibold text-[#4b585e]/70">
        {article.date} • {article.readTime}
      </span>
    </div>
    <h3 className="mt-4 text-lg font-extrabold tracking-tight text-[#0d2731] group-hover:text-[#176b70] transition-colors leading-snug">
      {article.title}
    </h3>
    <p className="mt-3 text-sm text-[#4b585e] leading-relaxed flex-1">{article.excerpt}</p>
    <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-[#176b70]">
      Lire l'article
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2.2} />
    </span>
  </Link>
);

export default ArticleCard;
